
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offshore/company-formation/cyprus",
      function () {
        return require("private-next-pages/offshore/company-formation/cyprus/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/offshore/company-formation/cyprus"])
      });
    }
  